import { Link, useLocation } from "react-router-dom";
import "./AdminHeader.css";

import { useDispatch, useSelector } from "react-redux";
import { authActions } from "_store";

export { AdminHeader };

const breadcrumbNameMap = {
  "/admin-user-list": "User List",
  "/admin-user-list/user-creation": "User Creation",
  "/admin-user-list/:userId": "User Details",
  "/jobs-list": "Jobs List",
};

function AdminHeader() {
  const dispatch = useDispatch();
  const logout = () => dispatch(authActions.logout());
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const auth = useSelector((x) => x.auth.value);
  const { firstName } = auth;

  const getBreadcrumbLabel = (pathname) => {
    if (breadcrumbNameMap[pathname]) return breadcrumbNameMap[pathname];
    for (const [key, label] of Object.entries(breadcrumbNameMap)) {
      const routePattern = new RegExp(`^${key.replace(/:[^/]+/g, "[^/]+")}$`);
      if (routePattern.test(pathname)) {
        return label;
      }
    }

    return "";
  };

  return (
    <header className="header d-flex align-center">
      <div className="header-body d-flex align-center justify-between">
        <div className="header-logo">
          <Link to="/admin-home/" className="d-flex">
            <img src="/images/LogoSmall.svg" alt="" />
          </Link>
        </div>
        <ul className="bedcrumbs p-0 d-flex align-center">
          <li className="relative d-flex align-center">
            <Link
              className="relative d-flex align-center justify-center"
              to="/admin-home/"
            >
              <span className="material-symbols-outlined">home</span>
            </Link>
          </li>

          {pathnames.map((value, index) => {
            const to = `/${pathnames.slice(0, index + 1).join("/")}`;
            const isLast = index === pathnames.length - 1;
            const label = getBreadcrumbLabel(to);

            return label ? (
              isLast ? (
                <li
                  key={to}
                  className="breadcrumb-item relative d-flex align-center"
                  style={{ fontWeight: 500 }}
                  aria-current="page"
                >
                  {label}
                </li>
              ) : (
                <li
                  key={to}
                  className="breadcrumb-item relative d-flex align-center"
                >
                  <Link
                    to={to}
                    className="relative d-flex align-center justify-center"
                  >
                    {label}
                  </Link>
                </li>
              )
            ) : null;
          })}
        </ul>
        <div className="header-user-sec d-flex align-items-center position-relative">
          <div className="h-user d-flex align-items-center">
            <div className="h-user-text">{firstName}</div>
            <span className="material-symbols-outlined">
              keyboard_arrow_down
            </span>
            {/* <div className="h-user-icon d-flex align-center justify-center">
              {" "}
              <span className="material-symbols-outlined">person</span>{" "}
            </div> */}
          </div>
          <div className="account-dropdown d-flex flex-column">
            <div className="account-dropdown-link">
              {" "}
              <a
                href="/"
                className="d-flex position-relative align-items-center"
              >
                <div className="acc-d-icon">
                  <span className="material-symbols-outlined">home</span>
                </div>
                <div className="acc-d-text d-flex">User Home</div>
              </a>{" "}
            </div>
            <div className="account-dropdown-link">
              {" "}
              <a
                href="/my-account/"
                className="d-flex position-relative align-items-center"
              >
                <div className="acc-d-icon">
                  <span className="material-symbols-outlined">person</span>
                </div>
                <div className="acc-d-text d-flex">My Profile</div>
              </a>{" "}
            </div>
        
            <div onClick={logout} className="account-dropdown-link logout-link cursor-pointer">
              {" "}
              <div
                className="d-flex position-relative align-items-center"
              >
                <div className="acc-d-icon">
                  <span className="material-symbols-outlined">logout</span>
                </div>
                <div className="acc-d-text d-flex">Logout</div>
              </div>{" "}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
